module.exports = __webpack_public_path__ + "assets/0d4396187356aa405b3f7f7222a40784.png";